import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_4c058a49800e347e952f5e812927d9d1_aa2e1349.jpg"
          alt="Serene forest with sunlight"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 py-32 flex flex-col lg:flex-row items-center gap-16">
        <div className="flex-1 text-white">
          <span className="inline-block text-green-400 text-xs font-semibold uppercase tracking-[0.2em] mb-6">
            {t('hero_tag')}
          </span>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
            {t('hero_title_line1')}<br />
            {t('hero_title_line2')}
          </h1>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="whitespace-nowrap cursor-pointer border border-white/60 hover:border-white text-white font-semibold px-8 py-3 rounded-md transition-colors duration-200 text-center"
            >
              {t('hero_contact_btn')}
            </Link>
          </div>
        </div>

        {/* Logo Card */}
        <div className="hidden lg:flex flex-shrink-0 w-96 h-80 bg-white rounded-2xl items-center justify-center p-10">
          <img
            src="https://storage.readdy-site.link/project_files/766ecf38-5aae-4b99-ad7c-3b9a28df6201/4b39bf62-c5e4-4bc8-a85b-8ffbe72ab4ca_VixtraLogo.png?v=a7e79daeb5093b144c08c9d5f97ff157"
            alt="Vixtra Inc. Logo"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
